import React, { createContext } from 'react'

const initialState = {
    loading:false
}

export const AuthContextProvider = createContext(initialState)

const AuthContext = ({children}) => {
    const [state1, setState] = React.useState(true);

  return (
   <AuthContextProvider.Provider value={{state1, setState}}>
    {children}
   </AuthContextProvider.Provider>
  )
}

export default AuthContext